export default "__VITE_ASSET__DrP8Wuq8__"